import {
  Destination,
  Organization,
  Provider,
  Route,
  buildDestination,
  buildDestinationType,
  buildOrganization,
  buildProvider,
  buildProviderType,
} from 'components/common/ObjectTypes';

// GUNDI-5665 (TEMPORARY, ≤3 weeks): the fake Route and Connection the tour
// walks through. Delivered to the REAL detail pages by tutorialInterceptor.ts,
// so the tour shows the actual UI rather than a screenshot of it.
//
// The ids are UUID-shaped so nothing that validates a URL param chokes on them,
// and distinctive enough to match on in the interceptor.
export const TUTORIAL_ROUTE_ID = '00000000-0000-4000-a000-000000000001';
export const TUTORIAL_CONNECTION_ID = '00000000-0000-4000-a000-000000000002';
export const TUTORIAL_PROVIDER_ID = '00000000-0000-4000-a000-000000000003';
export const TUTORIAL_ORG_ID = '00000000-0000-4000-a000-000000000004';
export const TUTORIAL_ROUTE_RECORD_ID = '00000000-0000-4000-a000-000000000005';

// Built through the repo's own factory functions so the fixtures can never
// drift from the entity types (Victor's rule: don't invent API fields).
const tutorialOrg: Organization = {
  ...buildOrganization(
    'Tutorial Workspace',
    'A sample workspace, visible only during the tutorial.',
    'admin',
  ),
  id: TUTORIAL_ORG_ID,
};

const tutorialProvider: Provider = {
  ...buildProvider(
    TUTORIAL_PROVIDER_ID,
    'Tutorial GPS Trackers',
    {
      ...buildProviderType(),
      id: '00000000-0000-4000-a000-00000000000a',
      name: 'Tutorial Trackers',
      value: 'tutorial_trackers',
      description: 'Sample source technology.',
      actions: [],
    },
    'https://tutorial-trackers.example.org',
    'healthy',
    // A LIST, not an object: the /v2 payload returns configurations as an
    // array of ConnectionConfiguration, and call sites do
    // `(configurations || []).find(...)`, which throws on `{}`.
    [],
    true,
  ),
  owner: tutorialOrg,
};

const tutorialDestination: Destination = {
  ...buildDestination(
    TUTORIAL_CONNECTION_ID,
    'Tutorial EarthRanger',
    {
      ...buildDestinationType(),
      id: '00000000-0000-4000-a000-00000000000b',
      name: 'EarthRanger',
      value: 'earth_ranger',
      description: 'Sample destination technology.',
      actions: [],
    },
    tutorialOrg,
    'https://tutorial.pamdas.org',
    true,
    [],
    'healthy',
  ),
};

export const tutorialRoute: Route = {
  id: TUTORIAL_ROUTE_ID,
  provider: tutorialProvider,
  destinations: [tutorialDestination],
  default_route: {
    id: TUTORIAL_ROUTE_RECORD_ID,
    name: 'Tutorial GPS Trackers - Tutorial EarthRanger',
  },
  owner: tutorialOrg,
  status: 'healthy',
  enabled: true,
};

export const tutorialConnection = tutorialDestination;
export const tutorialProviderIntegration = tutorialProvider;

// The tour does not need real activity: an empty page renders the "no activity"
// state, which is a perfectly good thing to show.
export const tutorialEmptyList = {
  results: [],
  count: 0,
  next: null,
  previous: null,
};
// A ROUTE RECORD (/v2/routes/), not a Connection: it carries its own name plus
// `data_providers` and `destinations`, which is what the Connection page's
// Routes tab and the Configurations tab read.
export const tutorialRouteRecord = {
  id: TUTORIAL_ROUTE_RECORD_ID,
  name: 'Tutorial GPS Trackers Route',
  owner: tutorialOrg,
  data_providers: [tutorialProvider],
  destinations: [tutorialDestination],
  configuration: null,
  data: {},
};
